/**
 * Copied from https://github.com/a8m/angular-filter#filterby
 */

const isString = angular.isString;
const isNumber = angular.isNumber;
const isObject = angular.isObject;
const isUndefined = angular.isUndefined;
const isArray = angular.isArray;

/**
 * @description
 * get an object and return array of values
 * @param object
 * @returns {Array}
 */
function toArray(object) {
  return isArray(object)
    ? object
    : Object.keys(object).map(function (key) {
        return object[key];
      });
}

/**
 * @ngdoc filter
 * @name filterBy
 * @kind function
 *
 * @description
 * filter by specific properties, avoid the rest
 */
export default angular
  .module('doxy.common.filters.filterBy', [])
  .filter('filterBy', [
    '$parse',
    function ($parse) {
      return function (collection, properties, search, strict) {
        var comparator;

        search =
          isString(search) || isNumber(search)
            ? String(search).toLowerCase()
            : undefined;

        collection = isObject(collection) ? toArray(collection) : collection;

        if (!isArray(collection) || isUndefined(search)) {
          return collection;
        }

        return collection.filter(function (elm) {
          return properties.some(function (prop) {
            /**
             * check if there is concatenate properties
             * example:
             * object: { first: 'foo', last:'bar' }
             * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
             */
            if (!~prop.indexOf('+')) {
              comparator = $parse(prop)(elm);
            } else {
              var propList = prop.replace(/\s+/g, '').split('+');
              comparator = propList
                .map(function (prop) {
                  return $parse(prop)(elm);
                })
                .join(' ');
            }

            if (!isString(comparator) && !isNumber(comparator)) {
              return false;
            }

            comparator = String(comparator).toLowerCase();

            return strict
              ? comparator === search
              : comparator.indexOf(search) > -1;
          });
        });
      };
    },
  ]).name;
